import { render, staticRenderFns } from "./EditorSubject.vue?vue&type=template&id=f77080e8&scoped=true&"
import script from "./EditorSubject.vue?vue&type=script&lang=js&"
export * from "./EditorSubject.vue?vue&type=script&lang=js&"
import style0 from "./EditorSubject.vue?vue&type=style&index=0&id=f77080e8&lang=scss&scoped=true&"
import style1 from "./EditorSubject.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77080e8",
  null
  
)

export default component.exports